var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    "label-size": "sm",
                    label: "Data Operator",
                    "label-cols": "4",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: { size: "sm", type: "text", readonly: "" },
                    model: {
                      value: _vm.record.operator,
                      callback: function ($$v) {
                        _vm.$set(_vm.record, "operator", $$v)
                      },
                      expression: "record.operator",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    "label-size": "sm",
                    label: "Temporary Owner",
                    "label-cols": "4",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: { size: "sm", type: "text", readonly: "" },
                    model: {
                      value: _vm.record.temporary_owner,
                      callback: function ($$v) {
                        _vm.$set(_vm.record, "temporary_owner", $$v)
                      },
                      expression: "record.temporary_owner",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    "label-size": "sm",
                    label: "Start date",
                    "label-cols": "4",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: { size: "sm", type: "text", readonly: "" },
                    model: {
                      value: _vm.record.start_date,
                      callback: function ($$v) {
                        _vm.$set(_vm.record, "start_date", $$v)
                      },
                      expression: "record.start_date",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    "label-size": "sm",
                    label: "End date",
                    "label-cols": "4",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: { size: "sm", type: "text", readonly: "" },
                    model: {
                      value: _vm.record.end_date,
                      callback: function ($$v) {
                        _vm.$set(_vm.record, "end_date", $$v)
                      },
                      expression: "record.end_date",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    "label-size": "sm",
                    label: "State",
                    "label-cols": "4",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: { size: "sm", type: "text", readonly: "" },
                    model: {
                      value: _vm.record.state,
                      callback: function ($$v) {
                        _vm.$set(_vm.record, "state", $$v)
                      },
                      expression: "record.state",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }